import { render } from "./HeroSubpage.vue?vue&type=template&id=1f6f2cc6&scoped=true&ts=true"
import script from "./HeroSubpage.ts?vue&type=script&lang=ts"
export * from "./HeroSubpage.ts?vue&type=script&lang=ts"

import "./HeroSubpage.scss?vue&type=style&index=0&id=1f6f2cc6&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6f2cc6"]])

export default __exports__